import { Component, OnInit } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { RoutingService } from './services/routing.service';
import { SeoService } from './services/seo.service';
import { NgwWowService } from 'ngx-wow';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CookiesModalComponent } from './components/cookies-modal/cookies-modal.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

})

export class AppComponent implements OnInit {
  title = 'wwfedu';
  private routeObs: Subscription;

  dialogConfig = new MatDialogConfig();
  modalDialog: MatDialogRef<CookiesModalComponent, any> | undefined;
  constructor(
    public route: RoutingService,
    public wowService: NgwWowService,
    public matDialog: MatDialog,
    public seo: SeoService
  ) {
    this.wowService.init();
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
      }, 10);
    });
    this.initializeApp();
  }

  ngOnInit(): void {
    this.route.setCurrent(window.location.pathname);
  }


  initializeApp() {

    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        console.log('Route Obvservable', window.location.pathname);
      }, 10);
    });
    this.seo.cookiesAcepted = localStorage.getItem('cookiesAcepted');
    if (localStorage.getItem('cookiesAcepted')) {
      this.seo.cookiesAcepted = localStorage.getItem('cookiesAcepted');
      if(this.seo.cookiesAcepted==0){
        window['ga-disable-GA_5MP9T7RSFS'] = true;
      }
      else{
        window['ga-disable-GA_5MP9T7RSFS'] = false;
      }
    }
    else {
      setTimeout(()=>{
        this.openModal();
      },2000);
    }
    /* if(this.seo.cookiesAcepted == '0' || !this.seo.cookiesAcepted ){

      this.openModal();
    } */
    /* this.userObs = this.user.profileChanged.subscribe(res => {
      console.log('USUARIO ACTUALIZADO', res)
    }); */
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any): void => {
      if (args.target.tagName === 'BODY') {
        this.seo.cookiesAcepted = true;
        localStorage.setItem('cookiesAcepted', '1');
        this.modalDialog?.close()
      }
    }
  }

  openModal() {
    this.dialogConfig.id = "projects-modal-component";
    this.dialogConfig.height = "500px";
    this.dialogConfig.width = "650px";
    this.modalDialog = this.matDialog.open(CookiesModalComponent, this.dialogConfig);
  }

}
